var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10.882,
    viewBox: "0 0 20 10.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    transform: "translate(-517.532 -602.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M532.613,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,532.613,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,532.613,641.165Z",
    transform: "translate(-10.555 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M589.183,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,589.183,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,589.183,641.165Z",
    transform: "translate(-55.459 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M536.825,608.031a9.193,9.193,0,0,0-3.338-1.28s-3.2-3.706-5.186-3.706c-.793,0-5.123-.088-5.123-.088-2.172,0-5.646,1.829-5.646,5.28v2.955a1.091,1.091,0,0,0,1.091,1.091h1.037c-.007-.075-.012-.151-.012-.228a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.012.228h6.869c-.007-.075-.011-.151-.011-.228a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.012.228h.434a.966.966,0,0,0,.931-1.091S537.787,608.9,536.825,608.031Zm-8.013,1.253a.344.344,0,0,1-.344.344h-.191a.344.344,0,0,1-.344-.344v-.843a.344.344,0,0,0-.344-.344h-.614a.344.344,0,0,0-.344.344v.843a.344.344,0,0,1-.344.344h-.2a.344.344,0,0,1-.344-.344v-2.978a.344.344,0,0,1,.344-.344h.2a.344.344,0,0,1,.344.344v.767a.344.344,0,0,0,.344.344h.614a.344.344,0,0,0,.344-.344v-.767a.344.344,0,0,1,.344-.344h.191a.344.344,0,0,1,.344.344Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHCar);
export default __webpack_public_path__ + "static/media/h-car.36fb6099.svg";
export { ForwardRef as ReactComponent };